import { render } from "./Panels-kong.vue?vue&type=template&id=2896124d&lang=pug"
import script from "./Panels-kong.vue?vue&type=script&setup=true&lang=js"
export * from "./Panels-kong.vue?vue&type=script&setup=true&lang=js"

import "./Panels-kong.vue?vue&type=style&index=0&id=2896124d&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__